import React, { forwardRef, useMemo } from 'react';

import StyledSelect from '../StyledSelect';
import styles from './ServiceSetsSection.module.scss';

export const ServiceSetSelect = forwardRef(function ServiceSetSelect(
  { onChange, onSelectedChange, options = [], value, ...props },
  ref
) {
  const serviceSetOptions = useMemo(
    () =>
      options.map((option) => {
        const comment = (option.comment || '').trim();

        if (!comment) {
          return option;
        }

        return {
          ...option,
          search: [option.search || option.text, comment].join(' '),
          content: (
            <span className={styles.serviceSetOption}>
              <span className={styles.serviceSetOptionName} title={option.text}>
                {option.text}
              </span>
              <span className={styles.serviceSetOptionComment} title={comment}>
                {comment.replace(/\s+/g, ' ')}
              </span>
            </span>
          ),
        };
      }),
    [options]
  );

  const handleChange = (nextValue) => {
    if (typeof onChange === 'function') {
      onChange(nextValue);
    }

    if (typeof onSelectedChange === 'function') {
      onSelectedChange(nextValue);
    }
  };

  return (
    <StyledSelect
      {...props}
      ref={ref}
      options={serviceSetOptions}
      value={value}
      onChange={handleChange}
    />
  );
});
